import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import { pdfService } from '../../../services/pdfService';
import { emailService } from '../../../services/emailService';

const ProgressSaveIndicator = ({ formData, pathway }) => {
  const [downloading, setDownloading] = useState(false);
  const [emailing, setEmailing] = useState(false);
  const [emailSuccess, setEmailSuccess] = useState(false);
  const [emailError, setEmailError] = useState('');

  const handleDownloadPDF = () => {
    try {
      setDownloading(true);
      pdfService?.downloadIntakePDF(formData, pathway);
    } catch (error) {
      console.error('PDF download error:', error);
    } finally {
      setDownloading(false);
    }
  };

  const handleEmailPDF = async () => {
    try {
      setEmailing(true);
      setEmailSuccess(false);
      setEmailError('');

      const pdfBlob = pdfService?.getIntakePDFBlob(formData, pathway);
      const { data, error, notDeployed } = await emailService?.sendIntakeProgressPDF(pdfBlob, pathway);

      if (notDeployed) {
        setEmailError('Email service not configured. Please download the PDF instead.');
      } else if (error) {
        setEmailError('Failed to send email. Please try downloading instead.');
      } else {
        setEmailSuccess(true);
        setTimeout(() => setEmailSuccess(false), 5000);
      }
    } catch (error) {
      console.error('Email PDF error:', error);
      setEmailError('An error occurred. Please try downloading instead.');
    } finally {
      setEmailing(false);
    }
  };

  return (
    <div className="mt-6 p-4 bg-muted/50 rounded-lg border border-border">
      <div className="flex items-start gap-3">
        <Icon name="Save" size={20} className="text-primary mt-0.5" />
        <div className="flex-1">
          <p className="text-foreground font-medium mb-1">Progress Saved</p>
          <p className="text-muted-foreground text-sm mb-4">
            Your information is automatically saved. You can return anytime to complete your intake.
          </p>
          
          <div className="flex flex-wrap items-center gap-3">
            <Button
              variant="outline"
              size="sm"
              onClick={handleDownloadPDF}
              disabled={downloading}
              iconName="Download"
              iconPosition="left"
            >
              {downloading ? 'Generating...' : 'Download PDF'}
            </Button>
            
            <Button
              variant="outline"
              size="sm"
              onClick={handleEmailPDF}
              disabled={emailing}
              iconName="Mail"
              iconPosition="left"
            >
              {emailing ? 'Sending...' : 'Email PDF'}
            </Button>
          </div>

          {emailSuccess && (
            <p className="text-green-600 text-sm mt-2 flex items-center gap-1">
              <Icon name="CheckCircle" size={16} />
              PDF sent to your email successfully!
            </p>
          )}
          
          {emailError && (
            <p className="text-amber-600 text-sm mt-2 flex items-center gap-1">
              <Icon name="AlertCircle" size={16} />
              {emailError}
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProgressSaveIndicator;